import { render, staticRenderFns } from "./MessagingHealth.vue?vue&type=template&id=533e4aa4&scoped=true&lang=pug"
import script from "./MessagingHealth.vue?vue&type=script&lang=js"
export * from "./MessagingHealth.vue?vue&type=script&lang=js"
import style0 from "./MessagingHealth.vue?vue&type=style&index=0&id=533e4aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e4aa4",
  null
  
)

export default component.exports